module.exports = __webpack_public_path__ + "assets/img/page-header-bg@2x.0a0be4f9.png";